import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavStateService {
	public hasShownMobileSidenav = false;
}
